import { BlockLoader } from './loading';

/** Fixed-height (h-64) centered loading spinner.
 *
 * Extracted from the access-management pages (MenuManagementPage /
 * MobileAccessTab / UserRoleAssignmentPage / WebAccessPage), where this exact
 * markup was duplicated inside each page's `if (loading)` early return.
 * Drawn with the loading kit's ring; the height (h-64) is what it always was. */
export function CenteredLoader() {
  return <BlockLoader className="h-64" />;
}
